import { formatDateTime } from './datetime';

// Message for a repeat scan, or null on the first scan of this purpose.
export function previousScanMessage(result) {
  const count = Number(result?.previousScanCount) || 0;
  if (count <= 0) return null;
  const last = result?.lastScannedAt ? `, last at ${formatDateTime(result.lastScannedAt)}` : '';
  return `Already scanned ${count} time${count === 1 ? '' : 's'} before${last}`;
}
